import { BlogDetailScreen } from '@bounty/creators-common/screens/blog/BlogDetail'
import { GetStaticPaths } from 'next'
import { Sanity } from '@bounty/common'
import {
  SANITY_DATASET,
  SANITY_PROJECT_ID,
} from '@bounty/creators-common/config/env'
import { withSEO } from '../../withSEO'
import { GetStaticPropsWithSEO } from '@bounty/creators-common/types'
import { NextPageWithLayout } from '../_app'
import { Layout } from '../../Layout'
import { ReactElement } from 'react'

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: 'blocking', // can also be true or 'blocking'
  }
}

export const getStaticProps: GetStaticPropsWithSEO<
  any,
  { slug: string }
> = async (context) => {
  const { slug } = context.params!

  const content = await new Sanity(
    SANITY_PROJECT_ID,
    SANITY_DATASET,
    'marketingSite',
  ).getBlog(slug)

  return {
    props: {
      fallback: {
        [Sanity.produceCacheKey('getBlog', slug)]: content,
      },
      seo: {
        title: content.title,
        description: content.description,
      },
    },
  }
}

const Page: NextPageWithLayout = withSEO(BlogDetailScreen)

Page.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>
}

export default Page
